import { Box } from '@mui/material';

import { CustomNameCellProps } from './CustomNameCell.types';

export const CustomNameCell = ({ image, value, style }: CustomNameCellProps) => {
  return (
    <Box display="flex" alignItems="center">
      <img
        alt="nameIcon"
        src={image || '/images/avatar.png'}
        style={{
          width: 32,
          height: 32,
          marginRight: '8px',
          borderRadius: '50%',
          ...style
        }}
      />
      {value}
    </Box>
  );
};